import api from './api';

class OrderService {
  // Create new order
  async createOrder(orderData) {
    try {
      const response = await api.post('/orders', orderData);
      return response.data;
    } catch (error) {
      console.error('Create order error:', error);
      throw error;
    }
  }

  // Get user orders
  async getUserOrders(page = 1, limit = 10) {
    try {
      const response = await api.get(`/orders?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Get user orders error:', error);
      throw error;
    }
  }

  // Get single order
  async getOrderById(orderId) {
    try {
      const response = await api.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      console.error('Get order error:', error);
      throw error;
    }
  }

  // Update order status
  async updateOrderStatus(orderId, status) {
    try {
      const response = await api.put(`/orders/${orderId}/status`, {
        status
      });
      return response.data;
    } catch (error) {
      console.error('Update order status error:', error);
      throw error;
    }
  }

  // Cancel order
  async cancelOrder(orderId) {
    try {
      const response = await api.put(`/orders/${orderId}/cancel`);
      return response.data;
    } catch (error) {
      console.error('Cancel order error:', error);
      throw error;
    }
  }

  // Get order tracking
  async getOrderTracking(orderId) {
    try {
      const response = await api.get(`/orders/${orderId}/tracking`);
      return response.data;
    } catch (error) {
      console.error('Get order tracking error:', error);
      throw error;
    }
  }

  // Process payment
  async processPayment(paymentData) {
    try {
      const response = await api.post('/payments/process', paymentData);
      return response.data;
    } catch (error) {
      console.error('Process payment error:', error);
      throw error;
    }
  }

  // Get payment methods
  async getPaymentMethods() {
    try {
      const response = await api.get('/payments/methods');
      return response.data;
    } catch (error) {
      console.error('Get payment methods error:', error);
      throw error;
    }
  }

  // Calculate shipping cost
  async calculateShipping(shippingData) {
    try {
      const response = await api.post('/shipping/calculate', shippingData);
      return response.data;
    } catch (error) {
      console.error('Calculate shipping error:', error);
      throw error;
    }
  }

  // Get shipping methods
  async getShippingMethods() {
    try {
      const response = await api.get('/shipping/methods');
      return response.data;
    } catch (error) {
      console.error('Get shipping methods error:', error);
      throw error;
    }
  }
}

export default new OrderService();
